module.exports = __webpack_public_path__ + "img/tarjeta-express.cd684991.webp";